import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
    min-width: 140px;
    margin-right: 15px;
    margin-bottom: 20px;
`;

const EmpImg = styled.img`
    width: 100px;
    height: 100px;
`;

const BranchEmployeeItem = ({ branchEmployee }) => {
    const userInfo = branchEmployee.userInfo;
    return (
        <Wrapper>
            {
                branchEmployee.role !== "regional-manager" && 
                <React.Fragment>
                    <EmpImg src={userInfo.imageUrl} />
                    <br />
                </React.Fragment>
            }

            {userInfo.firstName} {userInfo.lastName}
            <br />
            
            {
                branchEmployee.role !== "regional-manager" && 
                <React.Fragment>
                    Ext. {userInfo.phoneExtension}
                    <br />
                </React.Fragment>
            }
            
            Email{" "}
            <a href={`mailto:${userInfo.emailAddress}`}>{userInfo.firstName}</a>
        </Wrapper>
    );
};

export default BranchEmployeeItem;



// WEBPACK FOOTER //
// ./components/details/BranchEmployeeItem.jsx